import { I18n } from "i18n-js";
import en from "../translations/en.json";
import fr from "../translations/fr.json";

const locale = document.querySelector("html").getAttribute("lang") || "fr";

const i18n = new I18n(
  {
    en,
    fr
  },
  {
    locale
  }
);

export default i18n;
